export default __webpack_public_path__ + "static/id-607e749a03942a85bc93545c3b2a93ab.svg";